import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import dashboard from './slices/dashboardSlice'
import agama from './slices/agamaSlice'
import propinsi from './slices/propinsiSlice'
import kota from './slices/kotaSlice'
import pekerjaan from './slices/pekerjaanSlice'
import penghasilan from './slices/penghasilanSlice'
import kebutuhan_khusus from './slices/kebutuhanKhususSlice'
import pendidikan from './slices/pendidikanSlice'
import calonmhs from "./slices/calonMhsSlice"
import prestasi from "./slices/prestasiSlice"
import jenis_prestasi  from "./slices/jenisPrestasiSlice"
import satuan_pendidikan from "./slices/satuanPendidikanSlice";
import jurusan from "./slices/jurusanSlice"
import dokumen from "./slices/dokumenSlice"
import alat_transportasi from "./slices/alatTransportasiSlice"
import jenis_tinggal from "./slices/jenisTinggalSlice"
import pembayaran from "./slices/pembayaranSlice"
import pekerjaan_pasca from "./slices/pekerjaanPascaSlice"
import negara from "./slices/negaraSlice";

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        dashboard,
        agama,
        propinsi,
        kota,
        pekerjaan,
        penghasilan,
        kebutuhan_khusus,
        pendidikan,
        calonmhs,
        prestasi,
        jenis_prestasi,
        satuan_pendidikan,
        jurusan,
        dokumen,
        alat_transportasi,
        jenis_tinggal,
        pembayaran,
        pekerjaan_pasca,
        negara,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
